import { render, staticRenderFns } from "./cxDetails.vue?vue&type=template&id=0867b857&"
import script from "./cxDetails.vue?vue&type=script&lang=js&"
export * from "./cxDetails.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cxDetails.vue"
export default component.exports